import { combineReducers } from 'redux';
import {
  FETCH_ALGOS_TYPES_REQUEST,
  FETCH_ALGOS_TYPES_SUCCESS,
  FETCH_ALGOS_TYPES_FAILURE,
} from '../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_TYPES_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_TYPES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGOS_TYPES_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const algosTypes = combineReducers({
  list,
});

export default algosTypes;
